import { setupAmountTermLockout } from "../amount-term-lockout";

let contentCtaForms = $('.content-cta-form');
if (contentCtaForms.length > 0) {
    contentCtaForms.each((index, element) => {
        element = $(element);
        setupAmountTermLockout(element.find('[name=loan_amount]'), element.find('[name=loan_term]'));
    });
}